module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/js-industries-logo-270e5f0a7893ea54b4ce57f8d0cfd847.svg";